var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "carousel-editor" },
    [
      _c("h4", [_vm._v("Carousel Cards")]),
      _vm._v(" "),
      _c("p", { staticClass: "description" }, [
        _vm._v(
          "\n        These cards will appear as a second message after the general body text. Each card must have an image/video header and at least one button (up to 2 buttons). Card body text is optional and supports variables. You can add up to 10 cards.\n    "
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "carousel-cards-section" },
        _vm._l(_vm.cards, function (card, cardIndex) {
          return _c(
            "div",
            { key: cardIndex, staticClass: "carousel-card-item" },
            [
              _c(
                "div",
                { staticClass: "carousel-card-header" },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        gap: "8px",
                      },
                    },
                    [
                      _c("h5", [_vm._v("Card " + _vm._s(cardIndex + 1))]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "card-order-buttons" },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: {
                                size: "small",
                                disabled: cardIndex === 0,
                                title: "Move up",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.moveCardUp(cardIndex)
                                },
                              },
                            },
                            [_c("a-icon", { attrs: { type: "arrow-up" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              attrs: {
                                size: "small",
                                disabled: cardIndex === _vm.cards.length - 1,
                                title: "Move down",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.moveCardDown(cardIndex)
                                },
                              },
                            },
                            [_c("a-icon", { attrs: { type: "arrow-down" } })],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "link" },
                      on: {
                        click: function ($event) {
                          return _vm.removeCard(cardIndex)
                        },
                      },
                    },
                    [
                      _c("a-icon", { attrs: { type: "delete" } }),
                      _vm._v(" Remove\n                "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _vm._m(0, true),
                  _vm._v(" "),
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "150px", "margin-bottom": "8px" },
                      model: {
                        value: card.headerFormat,
                        callback: function ($$v) {
                          _vm.$set(card, "headerFormat", $$v)
                        },
                        expression: "card.headerFormat",
                      },
                    },
                    [
                      _c("a-select-option", { attrs: { value: "IMAGE" } }, [
                        _vm._v("Image"),
                      ]),
                      _vm._v(" "),
                      _c("a-select-option", { attrs: { value: "VIDEO" } }, [
                        _vm._v("Video"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "media-upload-section" }, [
                    card.media
                      ? _c(
                          "div",
                          { staticClass: "media-preview-box" },
                          [
                            card.headerFormat === "IMAGE"
                              ? _c("img", {
                                  attrs: {
                                    src: card.media.data,
                                    alt: "Preview",
                                  },
                                })
                              : card.headerFormat === "VIDEO"
                              ? _c("video", {
                                  attrs: { src: card.media.data, controls: "" },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "a-button",
                              {
                                staticClass: "remove-media-btn",
                                attrs: { type: "link" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeCardMedia(cardIndex)
                                  },
                                },
                              },
                              [_c("a-icon", { attrs: { type: "delete" } })],
                              1
                            ),
                            _vm._v(" "),
                            card.uploading
                              ? _c(
                                  "div",
                                  { staticClass: "upload-status" },
                                  [
                                    _c("a-spin", { attrs: { size: "small" } }),
                                    _vm._v(
                                      " Uploading to Meta...\n                        "
                                    ),
                                  ],
                                  1
                                )
                              : card.exampleMedia
                              ? _c(
                                  "div",
                                  { staticClass: "upload-success" },
                                  [
                                    _c("a-icon", {
                                      attrs: { type: "check-circle" },
                                    }),
                                    _vm._v(
                                      " Uploaded successfully\n                        "
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _c("div", { staticClass: "media-upload-box" }, [
                          _c("input", {
                            staticClass: "file-input",
                            attrs: {
                              type: "file",
                              accept:
                                card.headerFormat === "IMAGE"
                                  ? "image/jpeg, image/png"
                                  : "video/mp4",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.handleCardFileUpload(
                                  $event,
                                  cardIndex
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "upload-content" },
                            [
                              _c("a-icon", {
                                staticClass: "upload-icon",
                                attrs: { type: "cloud-upload" },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "upload-text" }, [
                                _vm._v("Drag and drop to upload"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "upload-link" }, [
                                _vm._v("Or choose files on your device"),
                              ]),
                            ],
                            1
                          ),
                        ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Card Body • Optional")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "body-editor-wrapper" },
                  [
                    _c("a-textarea", {
                      attrs: {
                        value: card.body,
                        placeholder: "Enter card body text (optional)",
                        rows: 3,
                        maxLength: 160,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.updateCardBody(
                            cardIndex,
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "editor-toolbar" },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.addCardVariable(cardIndex)
                              },
                            },
                          },
                          [
                            _c("a-icon", { attrs: { type: "plus" } }),
                            _vm._v(" Add Variable\n                        "),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "char-count" }, [
                          _vm._v(_vm._s((card.body || "").length) + "/160"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                card.bodyVariables && card.bodyVariables.length > 0
                  ? _c(
                      "div",
                      { staticClass: "variables-section" },
                      _vm._l(card.bodyVariables, function (variable, varIndex) {
                        return _c(
                          "div",
                          { key: varIndex, staticClass: "variable-example" },
                          [
                            _c("span", { staticClass: "variable-tag" }, [
                              _vm._v(_vm._s(variable.variable)),
                            ]),
                            _vm._v(" "),
                            _c("a-input", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                value: variable.example,
                                placeholder: "Sample value",
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.updateCardVariableExample(
                                    cardIndex,
                                    varIndex,
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _vm._m(1, true),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "buttons-list" },
                    _vm._l(card.buttons, function (button, buttonIndex) {
                      return _c(
                        "div",
                        {
                          key: buttonIndex,
                          staticClass: "button-item-wrapper",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "button-item" },
                            [
                              _c(
                                "a-select",
                                {
                                  staticStyle: { width: "150px" },
                                  model: {
                                    value: button.type,
                                    callback: function ($$v) {
                                      _vm.$set(button, "type", $$v)
                                    },
                                    expression: "button.type",
                                  },
                                },
                                [
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "QUICK_REPLY" } },
                                    [_vm._v("Quick Reply")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "URL" } },
                                    [_vm._v("Visit Website")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "PHONE_NUMBER" } },
                                    [_vm._v("Call Phone")]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("a-input", {
                                staticStyle: { flex: "1" },
                                attrs: {
                                  placeholder: "Button text",
                                  maxLength: 25,
                                },
                                model: {
                                  value: button.text,
                                  callback: function ($$v) {
                                    _vm.$set(button, "text", $$v)
                                  },
                                  expression: "button.text",
                                },
                              }),
                              _vm._v(" "),
                              button.type === "URL"
                                ? _c("a-input", {
                                    staticStyle: { flex: "1" },
                                    attrs: {
                                      placeholder:
                                        "https://example.com/" +
                                        "{{" +
                                        "1" +
                                        "}}",
                                    },
                                    model: {
                                      value: button.url,
                                      callback: function ($$v) {
                                        _vm.$set(button, "url", $$v)
                                      },
                                      expression: "button.url",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              button.type === "PHONE_NUMBER"
                                ? _c("a-input", {
                                    staticStyle: { flex: "1" },
                                    attrs: { placeholder: "+1234567890" },
                                    model: {
                                      value: button.phone_number,
                                      callback: function ($$v) {
                                        _vm.$set(button, "phone_number", $$v)
                                      },
                                      expression: "button.phone_number",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "a-button",
                                {
                                  style: {
                                    visibility:
                                      card.buttons.length === 1
                                        ? "hidden"
                                        : "visible",
                                  },
                                  attrs: {
                                    type: "link",
                                    disabled: card.buttons.length === 1,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeCardButton(
                                        cardIndex,
                                        buttonIndex
                                      )
                                    },
                                  },
                                },
                                [_c("a-icon", { attrs: { type: "delete" } })],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          button.type === "URL" && _vm.hasDynamicUrl(button.url)
                            ? _c(
                                "div",
                                { staticClass: "url-example-section" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "url-example-info" },
                                    [
                                      _c("a-icon", {
                                        attrs: { type: "info-circle" },
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "whatsapp_business_api.dynamicUrlSampleNote"
                                            )
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "url-example-input" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "variable-tag" },
                                        [_vm._v(_vm._s(1))]
                                      ),
                                      _vm._v(" "),
                                      _c("a-input", {
                                        staticStyle: { flex: "1" },
                                        attrs: { placeholder: "example_value" },
                                        model: {
                                          value: button.urlExample,
                                          callback: function ($$v) {
                                            _vm.$set(button, "urlExample", $$v)
                                          },
                                          expression: "button.urlExample",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  card.buttons.length < 2
                    ? _c(
                        "a-dropdown",
                        { attrs: { trigger: ["click"] } },
                        [
                          _c(
                            "a-button",
                            { attrs: { size: "small" } },
                            [
                              _c("a-icon", { attrs: { type: "plus" } }),
                              _vm._v(" Add button\n                    "),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-menu",
                            { attrs: { slot: "overlay" }, slot: "overlay" },
                            [
                              _c(
                                "a-menu-item",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.addCardButton(
                                        cardIndex,
                                        "QUICK_REPLY"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("a-icon", { attrs: { type: "message" } }),
                                  _vm._v(
                                    " Quick Reply\n                        "
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "a-menu-item",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.addCardButton(cardIndex, "URL")
                                    },
                                  },
                                },
                                [
                                  _c("a-icon", { attrs: { type: "link" } }),
                                  _vm._v(
                                    " Visit Website\n                        "
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "a-menu-item",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.addCardButton(
                                        cardIndex,
                                        "PHONE_NUMBER"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("a-icon", { attrs: { type: "phone" } }),
                                  _vm._v(
                                    " Call Phone\n                        "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.cards.length < 10
        ? _c(
            "a-button",
            {
              attrs: { type: "dashed", block: "" },
              on: { click: _vm.addCard },
            },
            [
              _c("a-icon", { attrs: { type: "plus" } }),
              _vm._v(" Add Card\n    "),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("Card Header "),
      _c("span", { staticClass: "required" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("Buttons "),
      _c("span", { staticClass: "required" }, [_vm._v("*")]),
      _vm._v(" (at least 1, up to 2)"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }